import { rootRouteRef } from './routes';

import rootReducer from "./reducers";
import { IAppState } from "./actions/types"; // the value from combineReducers
import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

export const routerVisualizerPlugin = createPlugin({
  id: 'router-visualizer',
  routes: {
    root: rootRouteRef,
  },
});

export const RouterVisualizerPage = routerVisualizerPlugin.provide(
  createRoutableExtension({
    name: 'router-visualizer',
    component: () =>
      import('./components/RootComponent').then(m => m.RootComponent),
    mountPoint: rootRouteRef,
  }),
);

export const RouterVisualizerReducer = rootReducer;

export type IRouterVisualizerAppState = IAppState;
